<template>
  <form @submit.prevent="submit">
    <base-modal small target="addInvestmentFunding" title="Add Funding Round">
      <base-field label="Name">
        <base-input v-model="payload.name" placeholder="name" required />
      </base-field>
      <base-field addon-left-icon="pound-sign" label="Funding">
        <base-input v-model="payload.funding" numeric placeholder="funding" required />
      </base-field>
      <base-field addon-right-icon="percent" label="Interest Rate">
        <base-input v-model="payload.interestRate" numeric placeholder="interest rate" />
      </base-field>
      <template v-slot:footer>
        <base-button :loading="saving" secondary submit>
          Save
        </base-button>
      </template>
    </base-modal>
  </form>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'InvestmentFundingCreateModal',

  data: () => ({
    payload: {
      name: '',
      funding: '',
      interestRate: ''
    },
    saving: false
  }),

  mounted () {
    this.payload.interestRate = this.investment.defaultInterestRate
  },

  computed: {
    ...mapState({
      investment: store => store.core.investments.entity
    })
  },

  methods: {
    submit () {
      this.saving = true

      this.create(this.payload)
        .then(async round => {
          await this.add(round)

          this.$emit('created', this.$_.cloneDeep(round))
          this.$flash.success('Funding round successfully created.')
          this.$modal.close('#addInvestmentFunding')

          this.payload.name = ''
          this.payload.funding = ''
          this.payload.interestRate = this.investment.defaultInterestRate
        })
        .catch(err => this.$flash.failure(err))
        .finally(() => {
          this.saving = false
        })
    },

    ...mapActions({
      add: 'core/investments/rounds/add',
      create: 'core/investment-funding/create'
    })
  }
}
</script>
